import ActionTypes from '../actions/ActionTypes';

const initialState = {
  loading: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.LOGIN_USER:
    case ActionTypes.GET_COMERCIAL_PLAN_PAGED:
    case ActionTypes.SAVE_NEGOTIATION:
    case ActionTypes.GET_MORE_COMERCIAL_PLAN:
    case ActionTypes.SEARCH_ALL_NEGOTIATIONS:
    case ActionTypes.FILL_NEGOTIATION_DETAIL:
    case ActionTypes.SEARCH_NEGOTIATIONS:
    case ActionTypes.FILL_COMPREHENSIVENESS:
    case ActionTypes.SAVE_CLIENT:
    case ActionTypes.LOGIN_USER:
    case ActionTypes.GET_PROJECTS:
    case ActionTypes.GET_COMERCIAL_PLAN_STATION:
    case ActionTypes.GET_PROJECT_STATION:
      return { ...initialState, loading: true };
    case ActionTypes.LOGIN_USER_SUCCESS:
    case ActionTypes.LOGIN_USER_FAIL:
    case ActionTypes.GET_COMERCIAL_PLAN_PAGED_FAIL:
    case ActionTypes.GET_COMERCIAL_PLAN_PAGED_SUCCESS:
    case ActionTypes.GET_MORE_COMERCIAL_PLAN_FAIL:
    case ActionTypes.GET_MORE_COMERCIAL_PLAN_SUCCESS:
    case ActionTypes.FILL_NEGOTIATION_DETAIL_FAIL:
    case ActionTypes.FILL_NEGOTIATION_DETAIL_SUCCESS:
    case ActionTypes.SEARCH_ALL_NEGOTIATIONS_FAIL:
    case ActionTypes.SEARCH_ALL_NEGOTIATIONS_SUCCESS:
    case ActionTypes.SEARCH_NEGOTIATIONS_FAIL:
    case ActionTypes.SEARCH_NEGOTIATIONS_SUCCESS:
    case ActionTypes.SAVE_NEGOTIATION_FAIL:
    case ActionTypes.SAVE_NEGOTIATION_SUCCESS:
    case ActionTypes.SAVE_CLIENT_FAIL:
    case ActionTypes.SAVE_CLIENT_SUCCESS:
    case ActionTypes.FILL_COMPREHENSIVENESS_FAIL:
    case ActionTypes.FILL_COMPREHENSIVENESS_SUCCESS:
    case ActionTypes.LOGIN_USER_FAIL:
    case ActionTypes.LOGIN_USER_SUCCESS:
    case ActionTypes.GET_PROJECTS_SUCCESS:
    case ActionTypes.GET_PROJECTS_FAIL:
    case ActionTypes.GET_COMERCIAL_PLAN_STATION_FAIL:
    case ActionTypes.GET_COMERCIAL_PLAN_STATION_SUCCESS:
    case ActionTypes.GET_PROJECT_STATION_FAIL:
    case ActionTypes.GET_PROJECT_STATION_SUCCESS:
      return { ...initialState, loading: false };
    default:
      return state;
  }
};
